import { useCallback, useEffect } from 'react'
import { useLocation, useParams } from 'react-router'
import { CategoryModelTypeExtended } from '../../ProductsParent/Categories/types'
import ModalCEMaterialCategory from './ModalCEMaterialCategory'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import { TwinTableLink } from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable, { BaseScreenTableSimple } from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderString, EditRowNotLink, DeleteRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { setVariablesToCurrentPage } from '../../../../../../utils/reducers/reduxDispatch'
import { getBasePath } from '../../../../../../utils/globals/link'
import ModalDeleteMaterialCategory from './ModalDeleteMaterialCategory'

interface MaterialCategoriesProps extends ComponentWithPermissions { }

const MaterialCategories: React.FC<MaterialCategoriesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const { CategoryId } = useParams()
    useCategoriesLogic()
    const pageData = {
        title: t('categoriesMaterial', 'Categorías de Materiales'),
        newText: t('newCategories', 'Nueva categoría')
    }
    if (!CategoryId) {
        return <BaseScreenTableSimple TableComponent={TableMaterialCategories} EditModalComponent={ModalCEMaterialCategory} DeleteModalComponent={ModalDeleteMaterialCategory} pageData={pageData} userPermissions={userPermissions} />
    }

    return (
        <BaseScreenTable TableComponent={TableMaterialCategories} CreateModalComponent={ModalCEMaterialCategory} EditModalComponent={ModalCEMaterialCategory} DeleteModalComponent={ModalDeleteMaterialCategory} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableMaterialCategoriesProps extends TableComponentProps { }

const TableMaterialCategories: React.FC<TableMaterialCategoriesProps> = ({ userPermissions, setTableInstance, setOpened }) => {
    const { t } = useTwinTranslation()
    const { CategoryId } = useParams()
    const location = useLocation()
    const basePath = getBasePath(location.pathname, 'categoriesMaterial')
    const extraWhereParams = { 'Category.CategoryId': CategoryId ? parseInt(CategoryId) : null, categoryMaterialType: CategoryId? 1: null }
    const columns: ColumnTableSchema<CategoryModelTypeExtended> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 75
        },
        {
            id: 'name',
            dataKey: 'CategoryLangs.name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            },
            customRender: (parameterValue) => <CustomRenderString value={parameterValue !== null ? parameterValue : t('base', 'Base')} />
        },
        {
            id: 'ref_code',
            dataKey: 'ref_code',
            label: t('code', 'Código'),
        },
    ]
    if (CategoryId) {
        columns.push({
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        })
        columns.push({
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        })
    }
    return (
        <TwinTableLink createRowDataLink={[basePath, ['$id']]} name='materialCategories' columns={columns} extraWhereParams={extraWhereParams} getDataFrom='/api/app/product/category/getAllCategories'  setTableInstance={setTableInstance} />
    )
}
const useCategoriesLogic = () => {
    const { CategoryId } = useParams()
    const {t} = useTwinTranslation()
    const baseStr = t('base', 'Base')
    const getData = useCallback(async () => {
        const categoryName = await twinFetchPostJSON('/api/app/product/category/getCategoryName', {
            id: CategoryId,
        })
        if (categoryName) {
            setVariablesToCurrentPage([categoryName['name'] || baseStr])
        }
    }, [baseStr, CategoryId])

    useEffect(() => {
        if (CategoryId) {
            getData()
        }
    }, [CategoryId, getData])
}

export default MaterialCategories